import { render, staticRenderFns } from "./ManageUserRolesTable.vue?vue&type=template&id=6cbdeec0&"
import script from "./ManageUserRolesTable.vue?vue&type=script&lang=js&"
export * from "./ManageUserRolesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports